export const SET_TEXT_FILTER = 'SET_TEXT_FILTER';
export const SORT_BY_EFFECTIVE_DATE = 'SORT_BY_EFFECTIVE_DATE';
export const SORT_BY_POSTED_DATE = 'SORT_BY_POSTED_DATE';
export const SORT_BY_AMOUNT = 'SORT_BY_AMOUNT';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const SEARCH_BY_VENDOR = 'SEARCH_BY_VENDOR';
export const SEARCH_BY_PURPOSE = 'SEARCH_BY_PURPOSE';
export const SEARCH_BY_ENTRY_NUMBER = 'SEARCH_BY_ENTRY_NUMBER';
export const DISPLAY_DIVISION = 'DISPLAY_DIVISION';

export const setTextFilter = (text = '') => ({ type: SET_TEXT_FILTER, text });


// Sort Methods
export const sortByEffectiveDate = () => {
  return ({
    type: SORT_BY_EFFECTIVE_DATE
  });
};

export const sortByPostedDate = () => {
  return ({
    type: SORT_BY_POSTED_DATE
  });
};

export const sortByAmount = () => {
  return ({
    type: SORT_BY_AMOUNT
  });
};

// Search Methods
export const searchByPurpose = () => {
  return ({
    type: SEARCH_BY_PURPOSE
  });
};

export const searchByEntryNumber = () => {
  return ({
    type: SEARCH_BY_ENTRY_NUMBER
  });
};

export const searchByVendor = () => {
  return ({
    type: SEARCH_BY_VENDOR
  });
};

export const displayDivision = (division) => {
  return ({
    type: DISPLAY_DIVISION,
    division
  });
};

// Dates Methods

export const setStartDate = (startDate) => {
  return ({
    type: SET_START_DATE,
    startDate
  });
};

export const setEndDate = (endDate) => ({
    type: SET_END_DATE,
    endDate
  });



// WEBPACK FOOTER //
// ./src/actions/filterActions.js